<div class="col-12 col-md-12">
    <ul class="devices-icon-view"></ul>
    <div class="clearfix"></div>
</div>
<app-device-list-empty tracker="tracker"></app-device-list-empty>
<ng-template #alerttemplate let-modal>
    <div class="modal-body text-center">
        <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
        <div class="alert-actions">
            <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
        </div>
    </div>
</ng-template>
<ng-template #deviceAlert let-modal>
    <div class="modal-body text-center">
        <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
        <div class="alert-actions">
            <button type="button" class="btn btn-danger" (click)="Yes()">{{"Yes" | translate}}</button>&nbsp;
            <button type="button" class="btn btn-success" (click)="No()">{{"No" | translate}}</button>&nbsp;
        </div>
    </div>
</ng-template>
<ng-template #alerttemplateSocketLost let-modal>
    <div class="modal-body text-center">
        <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
        <div class="alert-actions">
            <button type="button" class="btn btn-success" (click)="Reload()">{{"OK" | translate}}</button>&nbsp;
        </div>
    </div>
</ng-template>